import { render, staticRenderFns } from "./footballPropertyStatistics.vue?vue&type=template&id=5750ecce&scoped=true&"
import script from "./footballPropertyStatistics.vue?vue&type=script&lang=js&"
export * from "./footballPropertyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./footballPropertyStatistics.vue?vue&type=style&index=0&id=5750ecce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5750ecce",
  null
  
)

export default component.exports